import { Popover } from 'antd'
import * as React from 'react'

import { RequestedDepartmentFragment } from '@/generated/graphql'

interface DepartmentsDisplayProps {
  departments: RequestedDepartmentFragment[]
}

export const DepartmentsDisplay: React.FC<DepartmentsDisplayProps> = ({ departments }) => {
  if (departments.length === 0) {
    return null
  }

  const content = departments.map((d) => d.name).join(' - ')

  return (
    <Popover destroyTooltipOnHide placement='top' trigger={['hover']} content={content}>
      <span style={{ cursor: 'default' }}>{departments[0].name}</span>
    </Popover>
  )
}
